import BadgeIcon from '../_icons/BadgeIcon';
import BodySwitchIcon from '../_icons/BodySwitchIcon';
import GroupsIcon from '../_icons/GroupsIcon';
import MessageIcon from '../_icons/MessageIcon';
import PersonIcon from '../_icons/PersonIcon';
import SalesIcon from '../_icons/SalesIcon';
import ScheduleIcon from '../_icons/ScheduleIcon';
import StoreIcon from '../_icons/StoreIcon';
import DoorSlidingOutlinedIcon from '@mui/icons-material/DoorSlidingOutlined';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import BodySwitchManagment from '../components/bodySwitchManagement/BodySwitchManagment';
import EmployeeCreate from '../components/employee/EmployeeCreate';
import EmployeeDetail from '../components/employee/EmployeeDetail/EmployeeDetail';
import EmployeeSetting from '../components/employee/EmployeeSetting/EmployeeSetting';
import PayManagement from '../components/employee/PayManagement';
import PayrollCreate from '../components/employee/PayrollCreate';
import PayrollDetails from '../components/employee/PayrollDetails';
import SalarySettlementList from '../components/employee/salarySettlement/SalarySettlementList';
import SalarySettlementDetail from '../components/employee/salarySettlement/SalarySettlementDetail';
import SalarySetting from '../components/employee/SalarySetting/SalarySetting';
import Lesson from '../components/lesson';
import UnconfirmedAttendance from '../components/unconfirmedAttendance/UnconfirmedAttendance';
import GolfSpotManagement from '../components/golf/GolfSpotManagement';
import CorpManagement from '../components/member/CorpManagement';
import CorpManagementDetail from '../components/member/CorpManagementDetail';
import CreateManager from '../components/member/CreateManager';
import Event from '../components/message/Event';
import NoticeList from '../components/message/NoticeList';
import Transfer from '../components/message/Transfer/Transfer';
import NoticeDetail from '../components/message/NoticeDetail';
import NoticeCreate from '../components/message/NoticeCreate';
import ChatBranch from '../components/message/ChatBranch';
import SalesManagement from '../components/SalesManagment/SalesManagement';
import StoreManagement from '../components/StoreManagement';
import StoreCreate from '../components/storeTabs/StoreCreate';
import StoreDetails from '../components/storeTabs/storeDetails/StoreDetails';
import ProductManagement from '../components/storeTabs/productManagement/ProductManagement';
import LockerManagement from '../components/storeTabs/lockerManagment/LockerManagement';
import PointManagement from '../components/storeTabs/pointManagement/PointManagement';
import UserDetail from '../components/userDetails/UserDetail/UserDetail';
import MembersList from '../components/members/MembersList';
import MembersDetail from '../components/members/MembersDetail';
import TicketList from '../components/voucher/ticket/ticketList/TicketList';
import TicketEdit from '../components/voucher/ticket/ticketEdit/TicketEdit';
// TicketDetail은 TicketEdit으로 통합됨
import MemberIndex from '../components/member/MemberIndex';
import ListPass from '../components/voucher/pass/passList/ListPass';
import PassEdit from '../components/voucher/pass/passEdit/PassEdit';
import ListTrial from '../components/voucher/trial/trialList/ListTrial';
import TrialEdit from '../components/voucher/trial/trialEdit/TrialEdit';
import CreateVOD from '../components/vod/CreateVOD';
import DetailVOD from '../components/vod/DetailVOD';
import CreateBanner from '../components/banner/CreateBanner';
import ListBanner from '../components/banner/ListBanner';
import DetailBanner from '../components/banner/DetailBanner';
import TemporaryUserList from '../components/temporaryUser/temporaryUserList/TemporaryUserList';
import TemporaryUserEdit from '../components/temporaryUser/temporaryUserEdit/TemporaryUserEdit';
import MemberAppLinkList from '../components/memberAppLink/MemberAppLinkList';
import AttendHistoryList from '../components/attendHistory/AttendHistoryList';
import FacilityIcon from '../_icons/FacilityIcon';
import FacilityControl from '../components/facility/FacilityControl/FacilityControl';
import FaceAccessGroup from '../components/facility/FaceAccessGroup/FaceAccessGroup';
import AttendanceManagement from '../components/employee/AttendanceManagement/AttendanceManagement';
import SmsMain from '../components/sms/smsMain/SmsMain';
import PermissionSettings from '../components/storeTabs/permissionSettings/PermissionSettings';
import AppVersionManagement from '../components/settings/appVersionManagement/AppVersionManagement';

export const MenuList = [
  // {
  //   menuId: 2,
  //   name: 'Dashboard',
  //   order: 2,
  //   path: '/dashboard',
  //   icon: DashboardIcon,
  //   subMenus: [],
  //   component: Dashboard,
  // },
  {
    menuId: 3,
    name: 'Member management',
    order: 3,
    icon: PersonIcon,
    subMenus: [
      {
        menuId: 31,
        name: 'Managing unregistered members',
        order: 1,
        path: '/members',
        component: MembersList,
      },
      {
        menuId: 4,
        name: 'General member management',
        order: 2,
        path: '/member',
        component: MemberIndex,
      },
      {
        menuId: 5,
        name: 'Corporate member management',
        order: 3,
        path: '/corp',
        component: CorpManagement,
      },
      {
        menuId: 32,
        name: 'Managing temporary members',
        order: 4,
        path: '/temporary',
        component: TemporaryUserList,
      },
      {
        menuId: 226,
        name: 'App link requests',
        order: 5,
        path: '/member-app-link',
        component: MemberAppLinkList,
      },
    ],
  },
  {
    menuId: 33,
    name: 'Managing Attend Hisyory',
    order: 10,
    icon: DoorSlidingOutlinedIcon,
    subMenus: [],
    path: '/attendHistory',
    component: AttendHistoryList,
  },
  {
    menuId: 6,
    name: 'Schedule management',
    order: 4,
    icon: ScheduleIcon,
    subMenus: [
      {
        menuId: 7,
        name: 'private schedules',
        order: 1,
        path: '/private',
        component: Lesson,
      },
      {
        menuId: 8,
        name: 'Group Schedule',
        order: 2,
        path: '/group',
        component: Lesson,
      },
      {
        menuId: 9,
        name: 'Golf batting management',
        order: 3,
        path: '/online',
        component: GolfSpotManagement,
      },
      {
        menuId: 230,
        name: '수업·상담 관리',
        order: 4,
        path: '/unconfirmed-attendance',
        component: UnconfirmedAttendance,
      },
    ],
  },
  {
    menuId: 10,
    name: 'Membership management',
    order: 5,
    icon: BadgeIcon,
    subMenus: [
      {
        menuId: 11,
        name: 'Ticket management',
        order: 1,
        path: '/ticket',
        component: TicketList,
      },
      {
        menuId: 26,
        name: 'Pass management',
        order: 2,
        path: '/pass',
        component: ListPass,
      },
      // {
      //   menuId: 28,
      //   name: 'Center course VOD management',
      //   order: 2,
      //   path: '/vod',
      //   component: ListVOD,
      // },
      {
        menuId: 39,
        name: 'Center Trial ticket management',
        order: 3,
        path: '/trial',
        component: ListTrial,
      },
    ],
  },
  {
    menuId: 12,
    name: 'Body switch management',
    order: 6,
    icon: BodySwitchIcon,
    subMenus: [
      {
        menuId: 12,
        name: 'Body switch management',
        order: 1,
        path: '/bodySwitchManagement',
        component: BodySwitchManagment,
      },
    ],
    path: '/bodySwitchManagement',
    component: BodySwitchManagment,
  },
  {
    menuId: 13,
    name: 'Message management',
    order: 7,
    icon: MessageIcon,
    subMenus: [
      {
        menuId: 27,
        name: 'Chat',
        order: 1,
        path: '/chat',
        component: ChatBranch,
      },
      {
        menuId: 15,
        name: 'Notice',
        order: 2,
        path: '/notice',
        component: NoticeList,
      },
      {
        menuId: 16,
        name: 'Event',
        order: 3,
        path: '/event',
        component: Event,
      },
      {
        menuId: 29,
        name: 'Banner',
        order: 4,
        path: '/banner',
        component: ListBanner,
      },
      // {
      //   menuId: 17,
      //   name: 'Notification',
      //   order: 4,
      //   path: '/urgent',
      //   component: UrgentNotice,
      // },
      {
        menuId: 30,
        name: 'Transfer Menu',
        order: 5,
        path: '/transfer',
        component: Transfer,
      },
      {
        menuId: 41,
        name: 'SMS management',
        order: 6,
        path: '/sms',
        component: SmsMain,
      },
    ],
  },
  {
    menuId: 18,
    name: 'Employee management',
    order: 8,
    icon: GroupsIcon,
    subMenus: [
      {
        menuId: 19,
        name: 'Employee Setting',
        order: 1,
        path: '/employee',
        component: EmployeeSetting,
      },
      // {
      //   menuId: 20,
      //   name: 'Salary Management',
      //   order: 2,
      //   path: '/salary',
      //   component: PayManagement,
      // },
      {
        menuId: 21,
        name: 'Payroll System',
        order: 3,
        path: '/salarySettlement',
        component: SalarySettlementList,
      },
      {
        menuId: 44,
        name: '급여 설정',
        order: 4,
        path: '/salarySetting',
        component: SalarySetting,
      },
      {
        menuId: 40,
        name: 'Attendance management',
        order: 5,
        path: '/attendanceManagement',
        component: AttendanceManagement,
      },
    ],
  },
  {
    menuId: 22,
    name: 'Center management',
    order: 9,
    icon: StoreIcon,
    subMenus: [
      {
        menuId: 221,
        name: 'Center List',
        order: 1,
        path: '/store',
        component: StoreManagement,
      },
      {
        menuId: 222,
        name: 'Product Management',
        order: 2,
        path: '/product',
        component: ProductManagement,
      },
      {
        menuId: 223,
        name: 'Locker Management',
        order: 3,
        path: '/locker',
        component: LockerManagement,
      },
      {
        menuId: 224,
        name: 'Point Management',
        order: 4,
        path: '/point-management',
        component: PointManagement,
      },
      {
        menuId: 225,
        name: '권한 관리',
        order: 5,
        path: '/permission',
        component: PermissionSettings,
      },
    ],
  },
  {
    menuId: 23,
    name: 'Revenue Management',
    order: 10,
    icon: SalesIcon,
    subMenus: [],
    path: '/salesManagement',
    component: SalesManagement,
  },
  {
    menuId: 36,
    name: '시설 제어',
    order: 10,
    icon: FacilityIcon,
    subMenus: [
      {
        name: '시설 제어',
        path: '/facility-control',
        component: FacilityControl,
      },
      {
        name: '안면 인식 그룹',
        path: '/facility-control/face-access-group',
        component: FaceAccessGroup,
      },
    ],
    path: '/facility-control',
    component: FacilityControl,
  },
  {
    menuId: 37,
    name: '앱 버전 관리',
    order: 11,
    icon: SystemUpdateAltIcon,
    subMenus: [],
    path: '/app-version',
    component: AppVersionManagement,
  },
];

export const SubMenuList = [
  {
    name: 'Add Temporary User',
    path: '/temporary/create',
    component: TemporaryUserEdit,
    accessType: 'CREATE',
  },
  {
    name: 'Temporary User Details',
    path: '/temporary/:id',
    component: TemporaryUserEdit,
    accessType: 'READ',
  },
  {
    name: 'Member Details',
    path: '/member/:id',
    component: UserDetail,
    accessType: 'READ',
  },
  {
    name: 'Registered Member Details',
    path: '/members/:id',
    component: MembersDetail,
    accessType: 'READ',
  },
  {
    name: 'Add Corp Member',
    path: '/corp/create',
    component: CreateManager,
    accessType: 'CREATE',
  },
  {
    name: 'Member Details',
    path: '/corp/:id',
    component: CorpManagementDetail,
    accessType: 'READ',
  },
  {
    name: 'Add Ticket',
    path: '/ticket/create',
    component: TicketEdit,
    accessType: 'CREATE',
  },
  {
    name: 'Ticket Details',
    path: '/ticket/:id',
    component: TicketEdit,
    accessType: 'READ',
  },
  {
    name: 'Add Employee',
    path: '/employee/create',
    component: EmployeeCreate,
    accessType: 'CREATE',
  },
  {
    name: 'Employee Details',
    path: '/employee/:id',
    component: EmployeeDetail,
    accessType: 'READ',
  },
  {
    name: 'Add Store',
    path: '/store/create',
    component: StoreCreate,
    accessType: 'CREATE',
  },
  {
    name: 'Store Details',
    path: '/store/:id',
    component: StoreDetails,
    accessType: 'READ',
  },
  {
    name: 'Add Salary',
    path: '/salary/create',
    component: PayrollCreate,
    accessType: 'CREATE',
  },
  {
    name: 'Salary Details',
    path: '/salary/:id',
    component: PayrollDetails,
    accessType: 'READ',
  },
  {
    name: 'Settlement Detail',
    path: '/salarySettlement/:id',
    component: SalarySettlementDetail,
    accessType: 'READ',
  },
  {
    name: 'Add Pass',
    path: '/pass/create',
    component: PassEdit,
    accessType: 'WRITE',
  },
  {
    name: 'Pass Details',
    path: '/pass/:id',
    component: PassEdit,
    accessType: 'WRITE',
  },
  {
    name: 'Add Trial',
    path: '/trial/create',
    component: TrialEdit,
    accessType: 'WRITE',
  },
  {
    name: 'Trial Details',
    path: '/trial/:id',
    component: TrialEdit,
    accessType: 'WRITE',
  },
  {
    name: 'Add VOD',
    path: '/vod/create',
    component: CreateVOD,
    accessType: 'WRITE',
  },
  {
    name: 'VOD Details',
    path: '/vod/:id',
    component: DetailVOD,
    accessType: 'WRITE',
  },
  {
    name: 'Chat',
    path: '/chat',
    component: ChatBranch,
    accessType: 'WRITE',
  },
  {
    name: 'Chat',
    path: '/chat/:id',
    component: ChatBranch,
    accessType: 'WRITE',
  },
  {
    name: 'Banner',
    path: '/banner/create',
    component: CreateBanner,
    accessType: 'WRITE',
  },
  {
    name: 'Banner',
    path: '/banner/:id',
    component: DetailBanner,
    accessType: 'WRITE',
  },
  {
    name: 'Notice',
    path: '/notice/:id',
    component: NoticeDetail,
    accessType: 'WRITE',
  },
  {
    name: 'Notice',
    path: '/notice/create',
    component: NoticeCreate,
    accessType: 'WRITE',
  },
  {
    name: 'NotTransferice',
    path: '/transfer/:id',
    component: NoticeDetail,
    accessType: 'WRITE',
  },
  {
    name: 'Transfer',
    path: '/transfer/create',
    component: NoticeCreate,
    accessType: 'WRITE',
  },
];
